module.exports = __webpack_public_path__ + "img/dingtalk1.d68bd4aa.jpg";